package org.example.project.client.session

import kotlinx.serialization.Serializable
import org.example.project.client.model.UserProfileResponse

sealed interface SessionState {
    val isAuthenticated: Boolean

    data object Unauthenticated : SessionState {
        override val isAuthenticated: Boolean = false
    }

    data class AuthenticatedAndroid(
        val token: String,
        val expiresAtMillis: Long,
        val user: UserProfileResponse
    ) : SessionState {
        override val isAuthenticated: Boolean = true

        override fun toString(): String =
            "AuthenticatedAndroid(token=REDACTED, expiresAtMillis=$expiresAtMillis, user=$user)"
    }

    data class AuthenticatedWeb(
        val csrfToken: String?,
        val expiresAtMillis: Long,
        val user: UserProfileResponse,
        val reauthenticationRequiredForMutation: Boolean
    ) : SessionState {
        override val isAuthenticated: Boolean = true

        override fun toString(): String =
            "AuthenticatedWeb(csrfToken=REDACTED, expiresAtMillis=$expiresAtMillis, user=$user, reauthenticationRequiredForMutation=$reauthenticationRequiredForMutation)"
    }
}

sealed interface RemoteLogoutResult {
    data object Success : RemoteLogoutResult
    data class LocalOnly(val reason: String) : RemoteLogoutResult
    data class ClearFailed(val reason: String) : RemoteLogoutResult
}

@Serializable
sealed interface StoredSession {
    val baseUrl: String
    val expiresAtMillis: Long

    @Serializable
    data class Android(
        val token: String,
        override val expiresAtMillis: Long,
        val user: UserProfileResponse,
        override val baseUrl: String
    ) : StoredSession {
        override fun toString(): String =
            "StoredSession.Android(token=REDACTED, expiresAtMillis=$expiresAtMillis, user=$user, baseUrl=$baseUrl)"
    }

    @Serializable
    data class Web(
        val csrfToken: String?,
        override val expiresAtMillis: Long,
        override val baseUrl: String
    ) : StoredSession {
        override fun toString(): String =
            "StoredSession.Web(csrfToken=REDACTED, expiresAtMillis=$expiresAtMillis, baseUrl=$baseUrl)"
    }
}
